import { render, staticRenderFns } from "./labelAdd.vue?vue&type=template&id=124ded93&scoped=true"
import script from "./labelAdd.vue?vue&type=script&lang=js"
export * from "./labelAdd.vue?vue&type=script&lang=js"
import style0 from "./labelAdd.vue?vue&type=style&index=0&id=124ded93&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124ded93",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('124ded93')) {
      api.createRecord('124ded93', component.options)
    } else {
      api.reload('124ded93', component.options)
    }
    module.hot.accept("./labelAdd.vue?vue&type=template&id=124ded93&scoped=true", function () {
      api.rerender('124ded93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newLabelManagement/labelManagement/labelAdd.vue"
export default component.exports